import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

import { switchMap, take } from 'rxjs';

import { HttpInterceptorFn } from '@angular/common/http';
import { AuthenticationService } from '@auth/services/authentication.service';
import { environment } from '../../../environments/environment';

export const FortifyApiInterceptor: HttpInterceptorFn = (req, next) => {
  const _authenticationService = inject(AuthenticationService);
  const _oidcSecurityService = inject(OidcSecurityService);

  if (req.url.includes(environment.applications.fortify.api)) {
    return _authenticationService.isAuthenticated$.pipe(
      take(1),
      switchMap((isAuthenticated) => {
        if (isAuthenticated) {
          return _oidcSecurityService.getAccessToken().pipe(
            switchMap((accessToken) => {
              const modifiedRequest = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${accessToken}`,
                },
              });
              return next(modifiedRequest);
            }),
          );
        } else {
          return next(req);
        }
      }),
    );
  } else {
    return next(req); // No modify other requests.
  }
};
